import { useState } from "react";
import FilterMenuPopover from "./FilterMenuPopover";
import type {
  ConfirmedFilters,
  PendingDeletions,
  SelectedFilters,
  TempSelectedFilters,
} from "./filterTypes";

type FilterButtonProps = {
  currentFilters: SelectedFilters;
  onFiltersChange: (filters: SelectedFilters) => void;
  allFiltersData: any;
  visibleColumns?: string[];
  hiddenColumns?: string[];
  notAvailableColumns?: string[];
  columnsTitleCreator?: (column: string) => string;
};

const FilterButton = ({
  currentFilters,
  onFiltersChange,
  allFiltersData,
  visibleColumns = [],
  hiddenColumns = [],
  notAvailableColumns = [],
  columnsTitleCreator,
}: FilterButtonProps) => {
  const [open, setOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [tempSelectedFilters, setTempSelectedFilters] =
    useState<TempSelectedFilters>({});
  const [confirmedFilters, setConfirmedFilters] = useState<ConfirmedFilters>(
    {},
  );
  const [pendingDeletions, setPendingDeletions] = useState<PendingDeletions>(
    new Set(),
  );

  if (!allFiltersData) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <FilterMenuPopover
        open={open}
        setOpen={setOpen}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        tempSelectedFilters={tempSelectedFilters}
        setTempSelectedFilters={setTempSelectedFilters}
        confirmedFilters={confirmedFilters}
        setConfirmedFilters={setConfirmedFilters}
        pendingDeletions={pendingDeletions}
        setPendingDeletions={setPendingDeletions}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        allFiltersData={allFiltersData}
        visibleColumns={visibleColumns}
        hiddenColumns={hiddenColumns}
        notAvailableColumns={notAvailableColumns}
        columnsTitleCreator={columnsTitleCreator}
      />
    </div>
  );
};

export default FilterButton;
